// ISO 3166-1 alpha-2
enum RegionCode {
  ID = 'ID',
  PH = 'PH',
  NONE = ''
}

export default RegionCode;
